import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com'; // Import EmailJS
import droneImage from '../../assets/image/png/RPTO-Image-2.png';
// import logo from '../Image/Drone Planet Logo White.png';
import icon from '../../assets/image/png/Untitled-1_0000s_0006_Hue_Saturation-4.png';
import icon1 from '../../assets/image/png/Untitled-1_0000s_0007_Hue_Saturation-3.png';
import icon2 from '../../assets/image/png/Untitled-1_0000s_0008_Hue_Saturation-3-copy.png';
import { TextField, Button, Checkbox, FormControlLabel, Grid, Typography, Box } from '@mui/material';
import { Facebook, Instagram, LinkedIn, Twitter } from '@mui/icons-material';
const LandingPage = () => {
  // Create a ref to the form section
  const contactFormRef = useRef(null);
 
  // State to manage the notification visibility
  const [showNotification, setShowNotification] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
 
  // Handle form data change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
 
  // Function to handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
 
    // Send email using EmailJS
    emailjs.sendForm(
      'your_service_id', // Replace with your service ID
      'your_template_id', // Replace with your template ID
      e.target, // The form to send
      'your_user_id' // Replace with your user ID
    )
    .then((result) => {
      setShowNotification(true); // Show success notification
      setTimeout(() => setShowNotification(false), 3000); // Hide after 3 seconds
    })
    .catch((error) => {
      console.error('Error sending email:', error);
      setShowNotification(false); // Hide notification on failure
    });
 
    // Optionally reset form fields
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };
 
  // Function to scroll to the form
  const scrollToContactForm = () => {
    contactFormRef.current.scrollIntoView({ behavior: 'smooth' });
  };
 
  return (
    <div className="landing-page my-4">
      {/* Hero Section */}
      <header className="heros-section">
        <div className="heros-content">
        <h1 style={{ color: '#124a81', marginLeft: '140px', marginTop: '-35px' }}>
        Partner with Drone Planet: Launch Your DGCA-approved RPTO Franchise!
      </h1>
      <p style={{ color: '#2d5d8d', fontSize: '1em', marginLeft: '140px', marginTop: '-15px' }}>
        Join the drone revolution by opening a DGCA-approved Remote Pilot Training Organization (RPTO) with us and contribute to building the future of drone pilots.
      </p>
 
        </div>
      </header>
{/* Contact Form Section */}
<Box
  ref={contactFormRef}
  id="contact"
  sx={{
    position: 'absolute',
    top: '62%',
    top: {xs: "66%", sm: "62%"},
    right: '4%',
    transform: 'translateY(-50%)',
    width: 490,
    width: { xs: '95%', sm: '450px' },
    backgroundColor: '#008cff',
    padding: 2,
    borderRadius: 2,
    color: 'white',
    zIndex: 10,
    boxShadow: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: 'auto',
    maxHeight: 400,
    overflow: 'hidden',
    '@media (max-width: 414px) and (min-width: 375px)': {
      top: '78%', // Modify the top position for iPhones specifically
    },
  }}
>
  <form onSubmit={handleSubmit} className="contact-form">
    {/* Full Name and Email in the same row */}
    <Box sx={{ display: 'flex', gap: 2, height: "40px" }}>
      <TextField
        name="name"
        value={formData.name}
        onChange={handleChange}
        label="Full Name"
        variant="outlined"
        fullWidth
        required
        sx={{
          backgroundColor: 'white',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: 'none', // Remove the border
            },
            '&:hover fieldset': {
              border: 'none', // Remove border on hover
            },
            '&.Mui-focused fieldset': {
              border: 'none', // Remove border when focused
            },
          },
          '& input': {
            textAlign: 'center', // Center the text (including the placeholder)
            lineHeight: '1.2', // Move the cursor slightly up
          },
          '& .MuiInputLabel-root': {
            transform: 'translate(14px, 10px) scale(1)', // Adjust placeholder position (slightly up)
          },
          '& .MuiInputLabel-root.Mui-focused': {
            transform: 'translate(14px, -12px) scale(0.75)', // Keep the label in the same place when focused
          },
        }}
      />
      <TextField
        name="email"
        value={formData.email}
        onChange={handleChange}
        label="Email"
        variant="outlined"
        fullWidth
        required
        sx={{
          backgroundColor: 'white',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: 'none', // Remove the border
            },
            '&:hover fieldset': {
              border: 'none', // Remove border on hover
            },
            '&.Mui-focused fieldset': {
              border: 'none', // Remove border when focused
            },
          },
          '& input': {
            textAlign: 'center', // Center the text (including the placeholder)
            lineHeight: '1.2', // Move the cursor slightly up
          },
          '& .MuiInputLabel-root': {
            transform: 'translate(14px, 10px) scale(1)', // Adjust placeholder position (slightly up)
          },
          '& .MuiInputLabel-root.Mui-focused': {
            transform: 'translate(14px, -12px) scale(0.75)', // Keep the label in the same place when focused
          },
        }}
      />
    </Box>
 
    {/* Phone Number and Organization in the same row */}
    <Box sx={{ display: 'flex', gap: 2, height: "40px" }}>
      <TextField
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        label="Phone Number"
        variant="outlined"
        fullWidth
        required
        inputProps={{ pattern: '[0-9]{10}', maxLength: 10 }}
        sx={{
          backgroundColor: 'white',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: 'none', // Remove the border
            },
            '&:hover fieldset': {
              border: 'none', // Remove border on hover
            },
            '&.Mui-focused fieldset': {
              border: 'none', // Remove border when focused
            },
          },
          '& input': {
            textAlign: 'center', // Center the text (including the placeholder)
            lineHeight: '1.2', // Move the cursor slightly up
          },
          '& .MuiInputLabel-root': {
            transform: 'translate(14px, 10px) scale(1)', // Adjust placeholder position (slightly up)
          },
          '& .MuiInputLabel-root.Mui-focused': {
            transform: 'translate(14px, -12px) scale(0.75)', // Keep the label in the same place when focused
          },
        }}
      />
      <TextField
        name="organization"
        value={formData.organization}
        onChange={handleChange}
        label="Organization"
        variant="outlined"
        fullWidth
        required
        sx={{
          backgroundColor: 'white',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: 'none', // Remove the border
            },
            '&:hover fieldset': {
              border: 'none', // Remove border on hover
            },
            '&.Mui-focused fieldset': {
              border: 'none', // Remove border when focused
            },
          },
          '& input': {
            textAlign: 'center', // Center the text (including the placeholder)
            lineHeight: '1.2', // Move the cursor slightly up
          },
          '& .MuiInputLabel-root': {
            transform: 'translate(14px, 10px) scale(1)', // Adjust placeholder position (slightly up)
          },
          '& .MuiInputLabel-root.Mui-focused': {
            transform: 'translate(14px, -12px) scale(0.75)', // Keep the label in the same place when focused
          },
        }}
      />
    </Box>
 
    {/* City input */}
    <Box sx={{ display: 'flex', gap: 2, height: "40px" }}>
      <TextField
        name="city"
        value={formData.city}
        onChange={handleChange}
        label="City"
        variant="outlined"
        fullWidth
        required
        sx={{
          backgroundColor: 'white',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: 'none', // Remove the border
            },
            '&:hover fieldset': {
              border: 'none', // Remove border on hover
            },
            '&.Mui-focused fieldset': {
              border: 'none', // Remove border when focused
            },
          },
          '& input': {
            textAlign: 'center', // Center the text (including the placeholder)
            lineHeight: '2.3', // Move the cursor slightly up
          },
          '& .MuiInputLabel-root': {
            transform: 'translate(14px, 10px) scale(1)', // Adjust placeholder position (slightly up)
          },
          '& .MuiInputLabel-root.Mui-focused': {
            transform: 'translate(14px, -12px) scale(0.75)', // Keep the label in the same place when focused
          },
        }}
      />
    </Box>
 
    {/* Privacy Policy checkbox */}
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
  <FormControlLabel
    control={
      <Checkbox
        name="privacyPolicy"
        checked={formData.privacyPolicy}
        onChange={(e) =>
          setFormData({ ...formData, privacyPolicy: e.target.checked })
        }
        required
        sx={{
          color: 'white',
          '& .MuiSvgIcon-root': {
            color: 'white',
          },
          '&:hover': {
            backgroundColor: 'transparent',
          },
          // Move the checkbox upwards by adjusting marginTop
          marginTop: '-100px', // default for desktop
          '@media (max-width: 600px)': {
            marginTop: '-140px', // more negative margin for mobile
          },
        }}
      />
    }
    label={
      <Typography variant="body2" color="white" sx={{ marginTop: '2px' }}>
        By clicking submit below, you consent to allow Drone Plane to store and process the personal information
        submitted above to provide you the content requested. You may unsubscribe at any time. For more information,
        please see the full Drone Planet privacy policy.
      </Typography>
    }
  />
</Box>
 
 
    {/* Submit Button */}
    <Button
      type="submit"
      variant="contained"
      sx={{
        backgroundColor: '#123d67',
        marginTop: -2,
        padding: '10px 20px',
        '&:hover': {
          backgroundColor: '#0f2c4e',
        },
      }}
    >
      Submit
    </Button>
  </form>
 
  {/* Success Notification */}
  {showNotification && (
    <Box
      sx={{
        marginTop: 2,
        padding: 1,
        backgroundColor: 'green',
        color: 'white',
        borderRadius: 1,
        textAlign: 'center',
      }}
    >
      Your message has been sent!
    </Box>
  )}
 
  {/* Social Links */}
  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, marginTop: 2 }}>
    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-facebook"></i>
    </a>
    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-instagram"></i>
    </a>
    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-linkedin"></i>
    </a>
    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-twitter"></i>
    </a>
  </Box>
</Box>
 
 
 
 
      {/* Section 1: About Us */}
      <section id="about-we" className="about-we">
        <div className="about-we-content">
          <div className="about-we-text">
            <h2 style={{color:'#124a81'}}>Why Partner with Drone Planet?</h2>
            {/* <p style={{marginBottom:'10px'}}>Establishing an RPTO offers immediate benefits:</p> */}
            <ul>
              <li style={{marginBottom:'20px'}}><span style={{color: '#008cff', fontWeight: 'bold'}}>DGCA Certification Support: </span>We guide you through the approval process to ensure compliance with regulatory standards.</li>
              <li style={{marginBottom:'20px'}}><span style={{color: '#008cff', fontWeight: 'bold'}}>Established Brand: </span>Leverage Drone Planet’s reputation and industry expertise to attract aspiring drone pilots.</li>
              <li style={{marginBottom:'20px'}}><span style={{color: '#008cff', fontWeight: 'bold'}}>Proven Training Modules: </span>Access a curriculum crafted by industry leaders to produce top-notch drone professionals.</li>
              {/* <li style={{marginBottom:'20px'}}>Community Empowerment: Address local challenges through innovation.</li> */}
            </ul>
            <h2 style={{marginTop:'70px', color:'#124a81'}}>Franchise Benefits</h2>
            <ul>
              <li style={{marginBottom:'20px'}}><span style={{color: '#008cff', fontWeight: 'bold'}}>Revenue Opportunities: </span>Generate consistent income through training fees and certifications.</li>
              <li style={{marginBottom:'20px'}}><span style={{color: '#008cff', fontWeight: 'bold'}}>Comprehensive Setup Assistance: </span>From facility design to equipment procurement, we provide end-to-end support.</li>
              <li style={{marginBottom:'20px'}}><span style={{color: '#008cff', fontWeight: 'bold'}}>Ongoing Training & Support: </span>Get regular updates on training methodologies and regulatory changes.</li>
              {/* <li style={{marginBottom:'20px'}}>Sustainability Planning: Ensure the long-term success of your RPTO with strategic planning and capacity building.</li> */}
            </ul>
          </div>
       <div className="about-wee-image">
  <img
    src={droneImage}
    alt="Our Team"
    style={{  height: '100%' }} // Adjust width to 150% of its original size
  />
</div>
 
        </div>
      </section>
      <section
  className="video-section"
  style={{
  }}
>
  <div
    className="video-container"
    style={{
      position: 'relative',
      width: '100%',
      height: '400px',
      overflow: 'hidden',
      backgroundColor: 'white', // Ensures the background color is consistent for the video container
    }}
  >
    <video
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        backgroundColor: 'white', // Ensures the video element does not show any background
      }}
      src={require("../../assets/video/HAWK Videos 1_1.mp4")}
      autoPlay
      loop
      muted
    />
  </div>
</section>
      <section className="steps-to-open-franchise">
  <h2 style={{ textAlign: 'center', color: '#124a81', marginTop: '-40px' }}>
    Steps to Open Your Franchise
  </h2>
  <div className="steps-cardss">
    <div className="step-card">
      <div className="step-number">STEP 1</div>
     <div className="circle-icon">
        <img src={icon2}alt="Favicon" style={{ width: '58px', height: '58px' }} />
      </div>
      <h3>Submit Your Interest</h3>
      <p>Fill out a simple form to initiate the process.</p>
    </div>
    <div className="step-card">
      <div className="step-number">STEP 2</div>
      <div className="circle-icon">
      <img src={icon1}alt="Favicon" style={{ width: '59px', height: '59px' }} />
      </div>
      <h3>Discuss Requirements</h3>
      <p>Work with our team to finalize location, setup, and DGCA requirements.</p>
    </div>
    <div className="step-card">
      <div className="step-number">STEP 3</div>
      <div className="circle-icon">
      <img src={icon}alt="Favicon" style={{ width: '60px', height: '60px' }} />
      </div>
      <h3>Launch Your RPTO</h3>
      <p>Open your training center and start offering courses.</p>
    </div>
  </div>
 
 
  <div className="partner-message">
    <p className="line1">Partner with us and become a part of India’s growing drone ecosystem.</p>
    <p className="line2">
      <span>Together, </span><br />
      Let’s Train the Pilots of Tomorrow!
    </p>
  </div>
</section>
     
 
    </div>
  );
};
 
export default LandingPage;